import { IconWrapper, IconWrapperProps } from './IconWrapper';

interface StopIconProps extends IconWrapperProps {}

export const StopIcon = ({ ...props }: StopIconProps) => (
  <IconWrapper {...props}>
    <path
      d="M0 2.78261C0 1.24582 1.24582 0 2.78261 0H11.2174C12.7542 0 14 1.24582 14 2.78261V11.2174C14 12.7542 12.7542 14 11.2174 14H2.78261C1.24582 14 0 12.7542 0 11.2174V2.78261Z"
      fill="#EC544F"
    />
  </IconWrapper>
);

StopIcon.displayName = 'StopIcon';
